import type { CommandAck } from './contract'
import { StatusEmitter, type RealtimeStatus, type RealtimeTransport } from './transport'

export interface MemoryTransport extends RealtimeTransport {
  /** Simula um evento vindo do servidor (dev mock e testes). Payload vira envelope v1. */
  emit(event: string, ids?: Record<string, string>): void
  /** Comandos recebidos (para asserts nos testes). */
  readonly commands: { name: string; payload: unknown }[]
  setStatus(status: RealtimeStatus): void
}

let counter = 0

/** Transporte em memória para o modo mock e os testes: nenhum socket real é aberto. */
export function createMemoryTransport(): MemoryTransport {
  const status = new StatusEmitter()
  const handlers = new Map<string, Set<(payload: unknown) => void>>()
  const commands: { name: string; payload: unknown }[] = []
  return {
    commands,
    connect() {
      status.set('connected')
    },
    disconnect() {
      status.set('idle')
    },
    on(event, handler) {
      const set = handlers.get(event) ?? new Set()
      handlers.set(event, set)
      set.add(handler)
      return () => {
        set.delete(handler)
      }
    },
    onStatus: (listener) => status.subscribe(listener),
    setStatus: (next) => status.set(next),
    async command(name, payload): Promise<CommandAck> {
      commands.push({ name, payload })
      const topic = (payload as { topic?: string; schedule_id?: string } | undefined) ?? {}
      return {
        ok: true,
        room: topic.schedule_id
          ? `topic:${topic.topic}:${topic.schedule_id}`
          : `topic:${topic.topic}`,
      }
    },
    emit(event, ids = {}) {
      counter += 1
      const envelope = {
        v: 1,
        event,
        event_id: `00000000-0000-4000-8000-${String(counter).padStart(12, '0')}`,
        occurred_at: new Date().toISOString(),
        source: 'service',
        coalesced: 1,
        ...ids,
      }
      handlers.get(event)?.forEach((handler) => handler(envelope))
    },
  }
}
